module.exports = __webpack_public_path__ + "static/media/website-11.8277d19b.mp4";